import { defaultValueGet, defaultValuePathGet } from "common/parameters_common";
import { TopicResult } from "./dto/TopicResult";
import {
  INPUT_TYPE_TEXT,
  INPUT_TYPE_TEXT_FIELD,
} from "constant/topic/topic.const";
import { CharacterResult } from "common/character/dto/CharacterResult";
import { sortCharactersByPosition } from "common/character/position/character_position";

export type InputWayTextCharElement = {
  value: CharacterResult | string;
  isCharacter: boolean;
};

export function inputWayTextFieldGet(
  topic: TopicResult,
  fieldName: string = INPUT_TYPE_TEXT_FIELD.CONTENT
): string {
  const optionalFields = defaultValueGet(topic, "optionalFields", {});
  const textContent = defaultValuePathGet(
    optionalFields,
    [INPUT_TYPE_TEXT, fieldName],
    ""
  );

  return textContent;
}

export function inputWayTextCharElementsGet(
  textContent: string,
  unsortedCharacters: CharacterResult[]
): InputWayTextCharElement[] {
  const result: InputWayTextCharElement[] = [];
  let candidateInd: number = 0;
  let charInd: number = 0;
  const characters = sortCharactersByPosition(unsortedCharacters);
  const candidatesL = textContent.length;
  const charactersL = characters.length;
  let counter = 0;
  while (charInd < charactersL || candidateInd < candidatesL) {
    counter++;
    if (counter > 100000) {
      break;
    }
    const currentCharacter = characters[charInd];
    const charLength =
      currentCharacter && currentCharacter.letter
        ? currentCharacter.letter.length
        : 0;
    const current = textContent.substring(
      candidateInd,
      candidateInd + charLength
    );
    if (currentCharacter && current === currentCharacter.letter) {
      result.push({
        value: currentCharacter,
        isCharacter: true,
      });
      charInd++;
      candidateInd += charLength;
    } else {
      const candidate = textContent.substring(candidateInd, candidateInd + 1);
      if (result.length >= 1) {
        if (!result[result.length - 1].isCharacter) {
          result[result.length - 1].value += candidate;
        } else {
          result.push({
            value: candidate,
            isCharacter: false,
          });
        }
      } else {
        result.push({
          value: candidate,
          isCharacter: false,
        });
      }
      candidateInd++;
    }
  }

  return result;
}
